<template>
  <div>
    <basic-container>
      <el-tabs v-model="dataType" @tab-click="switchDataType">
        <el-tab-pane label="线上数据" name="onlineData"> </el-tab-pane>
        <el-tab-pane label="本地数据" name="localData">
          <!-- //^ ^-------------------------本地数据------------------------------------^ ^ -->
        </el-tab-pane>
      </el-tabs>
      <!-- //^ ^--------------搜索栏配置-------------^ ^ -->
      <el-form :inline="true" :model="searchParams">
        <el-form-item>
          <el-input clearable v-model="searchParams.id" placeholder="ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input clearable v-model="searchParams.rightsCode" placeholder="权益编号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input clearable v-model="searchParams.rightsName" placeholder="权益名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select clearable v-model="searchParams.state" placeholder="类型状态">
            <el-option v-for="item in state" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="dataType === 'localData'">
          <el-select clearable v-model="searchParams.reviewStatus" placeholder="审核状态">
            <el-option v-for="item in reviewStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :span="20">
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_SEARCH'" size="small" type="primary"
            @click="handleSearch">搜索</el-button>
          <el-button v-auth="'MEMBER_RIGHTS_MANAGE_ADD'" v-if="dataType === 'localData'" size="small" type="primary"
            @click="addDialog = true">新增</el-button>
        </el-form-item>
      </el-form>

      <MemberRightTable :list.sync="list" :currentTab="dataType" @updateData="updateData" />
      <ElementPagination style="margin-bottom: 20px;" :current-page="searchParams.current" :page-size="searchParams.size"
        :total="searchParams.total" :page-sizes="[10, 20, 30, 40, 50]" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </basic-container>
    <AddDialog :addDialog.sync="addDialog" title="新增会员权益" @updateData="updateData"></AddDialog>
  </div>
</template>

<script>
import { state } from "./enum/index.js";
import MemberRightTable from "./components/memberRightTable.vue";
import Message from "@/components/Message";
import ElementPagination from "@/components/ElementPagination";
import AddDialog from "./components/memberRightAddDialog.vue";
import {
  getMemberRightLocalList,
  getClientType,
  getLimitParams,
  getMemberRightOnlineList,
  getAuditStatusDict
} from "@/api/memberNew/memberRight.js";
import { statusTrans, auditStatusTrans } from "./helper/translator";
export default {
  name: "WebSassMemberRight",
  components: {
    MemberRightTable,
    ElementPagination,
    AddDialog
  },
  data() {
    return {
      /** 浏览数据类型 */
      dataType: "localData",
      /** 搜索参数 */
      searchParams: {
        current: 1,
        size: 10,
        total: 50,
        /** id */
        id: "",
        /** 权益编号 */
        rightsCode: "",
        /** 权益名称 */
        rightsName: "",
        /** 客户端类型 */
        // clientTypes: '',
        /** 类型状态 */
        state: "",
        /** 审核状态 */
        reviewStatus: ""
      },
      /** 客户端类型 */
      clientTypes: [],
      /** 类型状态 */
      state: state,
      /** 审核状态 */
      reviewStatus: "",
      /** list数组 */
      list: [],
      /** 新增对话框的显隐 */
      addDialog: false,
      /** 限制参数 */
      limitParams: []
    };
  },
  created() {
    Promise.all([this.loadClientTypes(), this.getLimitParams(), this.getAuditStatusDict()]).then(this.loadLocalTableData);
  },
  mounted() {
    // this.loadLocalTableData();
    // this.handleSearch();
  },
  methods: {
    /** 加载本地表数据 */
    async loadLocalTableData() {
      /** 先把list清空 */
      this.list = [];
      const { data } = await getMemberRightLocalList(this.searchParams);
      console.log("加载本地表数据的响应", data);
      data.data.records.map(item => {
        item.clientTypes = this.translateClientType(item.clientTypes);
        item.limitParams = this.translateLimitParams(item.limitParams);
        item.state = statusTrans(item.state);
        item.reviewStatus = auditStatusTrans(item.reviewStatus);
      });
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
    },
    /** 加载线上表数据 */
    async loadOnlineTableData() {
      /** 先把list清空 */
      this.list = [];
      const { data } = await getMemberRightOnlineList(this.searchParams);
      console.log("加载线上表数据的响应", data);
      data.data.records.map(item => {
        item.clientTypes = this.translateClientType(item.clientTypes);
        item.limitParams = this.translateLimitParams(item.limitParams);
        item.state = statusTrans(item.state);
        // item.reviewStatus = auditStatusTrans(item.reviewStatus);
      });
      this.list = data.data.records;
      this.searchParams.total = data.data.total;
    },
    /** 加载客户端类型 */
    async loadClientTypes() {
      const { data } = await getClientType();
      console.log("加载客户端类型的响应", data.data[0].children);
      this.clientTypes = data.data[0].children;
    },
    /** 获取限制参数 */
    async getLimitParams() {
      const { data } = await getLimitParams();
      console.log("获取限制参数的响应", data.data[0].children);
      this.limitParams = data.data[0].children
    },
    /** 切换数据类型事件 */
    switchDataType(dataType) {
      console.log(dataType.name);
      /** 根据不同的类型调用不同的接口 */
      /** 调用之前 先清空searchParams */
      this.searchParams = {
        current: 1,
        size: 10,
        total: 50,
        /** id */
        id: "",
        /** 权益编号 */
        rightsCode: "",
        /** 权益名称 */
        rightsName: "",
        /** 客户端类型 */
        // clientTypes: '',
        /** 类型状态 */
        state: "",
        /** 审核状态 */
        reviewStatus: ""
      };
      switch (dataType.name) {
        case "localData":
          Message.success("切换到本地数据");
          this.loadLocalTableData();
          break;
        case "onlineData":
          Message.success("切换到线上数据");
          this.loadOnlineTableData();
          break;
        default:
          break;
      }
    },
    /** 点击搜索按钮事件 */
    handleSearch() {
      Message.success("搜索成功");
      /** 处理客户端类型变为字符串数组 */
      console.log("搜索参数", this.searchParams);
      /** 根据不同的数据类型触发不同的方法 */
      if (this.dataType === "localData") {

        this.loadLocalTableData();
      } else {
        this.loadOnlineTableData();
      }
    },
    /** 子组件要求更新数据 */
    updateData() {
      this.loadLocalTableData();
    },
    //^ ^--------------分页相关 start-------------^ ^
    /** 每页条数change */
    handleSizeChange(val) {
      this.searchParams.size = val;
      Message.success(`每页 ${val} 条`);
      /** 更新数据 */
      /** 根据当前浏览数据更新数据 */
      if (this.dataType === 'localData') {
        this.loadLocalTableData();
      } else {
        this.loadOnlineTableData();
      }
    },
    /** 当前页change */
    handleCurrentChange(val) {
      this.searchParams.current = val;
      Message.success(`当前页 ${val}`);
      /** 更新数据 */
      /** 根据当前浏览数据更新数据 */
      if (this.dataType === 'localData') {
        this.loadLocalTableData();
      } else {
        this.loadOnlineTableData();
      }
    },
    //^ ^--------------分页相关 end-------------^ ^
    /** //^ ^--------------初始化数据-------------^ ^ */
    //^ ^--------------数据转化-------------^ ^
    /** 客户端类型转化 */
    translateClientType(clientTypes) {
      // 如果 this.clientTypes 为空或长度为0，则返回空字符串
      // if (!this.clientTypes || this.clientTypes.length === 0) {
      //   return "";
      // }
      // debugger
      // 将传入的字符串按逗号分隔为数组
      const keyArr = clientTypes.split(",");
      // const clientTypeArray = this.clientTypes.split(",");
      // 处理每个键对应的客户端类型值
      const translatedArr = keyArr.map(key => {
        const clientType = this.clientTypes.find(item => item.dictKey === key);
        return clientType ? clientType.dictValue : "";
      });

      // 返回用逗号隔开的字符串
      return translatedArr.join(",");
    },

    /** 限制参数类型转化 */
    translateLimitParams(limitParam) {
      // // 如果 this.limitParams 为空或长度为0，则返回空字符串
      // if (!this.limitParams || this.limitParams.length === 0) {
      //   return "";
      // }
      // 将传入的字符串按逗号分隔为数组
      const keyArr = limitParam.split(",");
      // const limitParamsArray = this.limitParams.split(",");
      // 处理每个键对应的客户端类型值
      const translatedArr = keyArr.map(key => {
        const limitParam = this.limitParams.find(item => item.dictKey === key);
        return limitParam ? limitParam.dictValue : "无限制参数";
      });

      // 返回用逗号隔开的字符串
      return translatedArr.join(",");
    },
    //^ ^--------------从字典获取数据-------------^ ^
    /** 获取审核状态字典 */
    async getAuditStatusDict() {
      const { data } = await getAuditStatusDict()
      console.log('审核状态字典', data.data.records);
      this.reviewStatus = data.data.records.map((item => {
        return {
          label: item.dictValue,
          value: Number(item.dictKey)
        }
      }))
    }
  }
};
</script>

<style scoped></style>
